import React from 'react';
import './Footer.css';
import { MailIcon } from '../MailIcon';
import { PhoneIcon } from '../PhoneIcon';
import { MessageCircleIcon } from '../MessageCircleIcon';
import { MapPinIcon } from '../MapPinIcon';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/logo.png" alt="Octopus Industries" />
              <h3>Octopus Industries</h3>
            </div>
            <p className="footer-description">
              Leading provider of innovative industrial packaging solutions. Specializing in customized packaging, wooden crates, corrugated boxes, and complete packaging consumables for diverse industries.
            </p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><button onClick={() => scrollToSection('home')}>Home</button></li>
              <li><button onClick={() => scrollToSection('about')}>About Us</button></li>
              <li><button onClick={() => scrollToSection('services')}>Products & Services</button></li>
              <li><button onClick={() => scrollToSection('customers')}>Our Customers</button></li>
              <li><button onClick={() => scrollToSection('contact')}>Contact</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Our Products</h4>
            <ul className="footer-links">
              <li>Heavy Duty Corrugated Boxes</li>
              <li>Wooden Boxes & Crates</li>
              <li>Honeycomb Partition Boxes</li>
              <li>Plastic Strapping & Clips</li>
              <li>Dunnage Air Bags</li>
              <li>Shrink Wrap & Bubble Sheets</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul className="footer-contact">
              <li><MailIcon size={16} /> <a href="mailto:sales@octopusindustries.in">sales@octopusindustries.in</a></li>
              <li><PhoneIcon size={16} /> <a href="tel:+918421717125">+91 8421717125</a></li>
              <li><MessageCircleIcon size={16} /> <a href="https://wa.me/918421717125" target="_blank" rel="noopener noreferrer">WhatsApp Chat</a></li>
              <li><MapPinIcon size={16} />Yashwant Nagar, Talegaon Dabhade, Pune – 410507, Maharashtra, India</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Octopus Industries. All rights reserved.</p>
          <p className="gst-info">GST Number: 27CFKPJ2925L1Z3</p>
          {/* <div className="social-links">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">in</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">𝕏</a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">f</a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
